import { api, apiFile, transformParams } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import Atividade from "model/gestao/atividades/Atividade";
import AtividadeApontamento from "model/gestao/atividades/AtividadeApontamento";
import AtividadeApontamentoAgrupado from "model/gestao/atividades/AtividadeApontamentoAgrupado";
import AtividadeApontamentoAgrupamentoFiltro from "model/gestao/atividades/AtividadeApontamentoAgrupamentoFiltro";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class AtividadeApontamentoService implements BaseServiceCadastros<AtividadeApontamento> {

    pesquisar(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            const url = `/atividadeapontamento/pesquisar`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarAgrupado(filtro: AtividadeApontamentoAgrupamentoFiltro) {

        return new Promise<AtividadeApontamentoAgrupado>((resolve, reject): void => {
            let url = `/atividadeapontamento/pesquisarAgrupado`;
            //url += `tipoAgrupamento=${filtro.tipoAgrupamento}`;

            const params = {
                tipoAgrupamento: filtro.tipoAgrupamento,
                dataInicio: filtro.dataInicio,
                dataFim: filtro.dataFim,
                idTecnico: filtro.idTecnico,
                idCliente: filtro.idCliente,
                idAtividade: filtro.idAtividade,
                mostraUsuariosInativos: filtro.mostraUsuariosInativos,
                cobranca: filtro.cobranca,
                faturado: filtro.faturado
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<AtividadeApontamento>((resolve, reject): void => {
            api
                .get(`/atividadeapontamento/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(data: FormData) {
        return new Promise<AtividadeApontamento>((resolve, reject): void => {
            apiFile
                .post(`/atividadeapontamento/incluir`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(data: FormData) {
        return new Promise<AtividadeApontamento>((resolve, reject): void => {
            apiFile
                .put(`/atividadeapontamento/editar`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    alterarFaturamento(id: number, faturado: boolean) {
        return new Promise<AtividadeApontamento>((resolve, reject): void => {
            api
                .put(`/atividadeapontamento/alterar-faturamento/${id}/${faturado}`, {})
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/atividadeapontamento/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    tecnicos() {
        return new Promise<Array<Usuario>>((resolve, reject): void => {
            let url = `/atividadeapontamento/tecnicos`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    atividades() {
        return new Promise<Array<Atividade>>((resolve, reject): void => {
            let url = `/atividadeapontamento/atividades`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Array<Pessoa>>((resolve, reject): void => {
            let url = `/atividadeapontamento/clientes`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    relatorioApontamentos(filtro: AtividadeApontamentoAgrupamentoFiltro) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/atividadeapontamento/relatorio-apontamentos`;

            const params = transformParams({
                tipoAgrupamento: filtro.tipoAgrupamento,
                dataInicio: filtro.dataInicio,
                dataFim: filtro.dataFim,
                idTecnico: filtro.idTecnico,
                idCliente: filtro.idCliente,
                idAtividade: filtro.idAtividade,
                cobranca: filtro.cobranca,
                faturado: filtro.faturado
            });

            api
                .get(url, { params, responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    relatorioApontamentosAnalitico(filtro: AtividadeApontamentoAgrupamentoFiltro) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/atividadeapontamento/relatorio-apontamentos-analitico`;

            const params = transformParams({
                tipoAgrupamento: filtro.tipoAgrupamento,
                dataInicio: filtro.dataInicio,
                dataFim: filtro.dataFim,
                idTecnico: filtro.idTecnico,
                idCliente: filtro.idCliente,
                idAtividade: filtro.idAtividade,
                cobranca: filtro.cobranca,
                faturado: filtro.faturado
            });

            api
                .get(url, { params, responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default AtividadeApontamentoService;
